import type { ReactNode } from 'react';
import { AuthContext } from './context';
import { useDevAuth } from './useDevAuth';
import { useSupabaseAuth } from './useSupabaseAuth';
import type { AppConfig } from '@/config';
import { config as defaultConfig } from '@/config';

interface AuthProviderProps {
  children: ReactNode;
  config?: AppConfig;
}

/** Picks the auth mode from configuration: Supabase unless VITE_AUTH_MODE=dev. */
export function AuthProvider({ children, config = defaultConfig }: AuthProviderProps) {
  const dev = useDevAuth(config, config.authMode === 'dev');
  const supabase = useSupabaseAuth(config, config.authMode === 'supabase');
  const value = dev ?? supabase;
  if (!value) throw new Error(`Unknown auth mode ${config.authMode}`);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
